export { default } from './svg/check.svg';
